import { InputDecorationStateType, } from '@kubit/web-ui-components/inputDecoration/types';
import { commonStyles } from '../commonStyles';
import { InputDecorationVariantType } from '../variants';
export const getInputDecorationMainSectionStyles = (FOUNDATIONS, FONT) => {
    return {
        [InputDecorationVariantType.MAIN_SECTION]: {
            ...commonStyles(FOUNDATIONS, {
                [InputDecorationStateType.FOCUSED]: {},
                [InputDecorationStateType.EMPTY]: {},
                [InputDecorationStateType.FILLED]: {},
                [InputDecorationStateType.ERROR_EMPTY]: {},
                [InputDecorationStateType.ERROR_FILLED]: {},
                [InputDecorationStateType.DISABLED_EMPTY]: {
                    decoration: {
                        color: FOUNDATIONS.color_accent_disabled_icon_mainsection_100,
                    },
                },
                [InputDecorationStateType.DISABLED_FILLED]: {
                    decoration: {
                        color: FOUNDATIONS.color_accent_disabled_icon_mainsection_50,
                    },
                },
            }),
        },
    };
};
//# sourceMappingURL=mainSection.js.map